export const EDIT_PRODUCT_MUTATION = `
\tmutation EditProduct ($productId: ID!,
  $assignedCharacteristics: [ID!]!,
    $assignedTemplates:[EditProductTemplate!]!,
    $textProperties: [TextProductInputTypeValues!]!,
    $dropdownProperties: [DropdownProductInputType!]!
  ){ 
  \teditProduct(productId: $productId,
    \tassignedCharacteristics: $assignedCharacteristics,
      assignedTemplates: $assignedTemplates,
      textProperties: $textProperties,
      dropdownProperties: $dropdownProperties
    )
  }
`